import { useEffect, useState } from "react";
import { Check, X, UserPlus } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "../../lib/api";
import { ApproveDialog } from "../dashboard/RegistrationsPanel";

const TYPE = { agent: "Agente", customer: "Cliente privato", b2b: "Cliente B2B" };

export default function MobileRegistrations() {
  const [pending, setPending] = useState([]);
  const [agents, setAgents] = useState([]);
  const [approving, setApproving] = useState(null);

  const load = () => Promise.all([api.get("/registrations?status=pending"), api.get("/agents")])
    .then(([p, a]) => { setPending(p.data); setAgents(a.data.filter((x) => x.status !== "pending")); }).catch(() => {});
  useEffect(() => { load(); }, []);

  const reject = async (u) => {
    if (!window.confirm(`Rifiutare ${u.name}?`)) return;
    try { await api.put(`/registrations/${u.id}/reject`); toast.success("Rifiutata"); load(); } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };

  if (pending.length === 0) return null;
  return (
    <div className="mb-6" data-testid="mobile-registrations">
      <h2 className="font-serif text-lg font-semibold text-[#0B2A45] flex items-center gap-2 mb-3"><UserPlus className="w-5 h-5 text-[#C2593F]" />Da approvare <span className="text-sm bg-amber-100 text-amber-800 rounded-full px-2 py-0.5">{pending.length}</span></h2>
      <div className="space-y-3">
        {pending.map((u) => (
          <div key={u.id} className="bg-white rounded-2xl border border-amber-200 p-4" data-testid={`mobile-pending-${u.id}`}>
            <div className="text-[11px] uppercase tracking-wide font-semibold text-[#C2593F]">{TYPE[u.account_type]}</div>
            <div className="font-semibold text-[#0B2A45]">{u.name}{u.business && <span className="text-stone-500 font-normal"> · {u.business}</span>}</div>
            <div className="text-xs text-stone-500">{u.email}{u.phone && ` · ${u.phone}`}{(u.zone || u.city) && ` · ${u.zone || u.city}`}</div>
            {u.notes && <p className="text-xs text-stone-500 italic mt-1">{u.notes}</p>}
            <div className="flex gap-2 mt-3 pt-3 border-t border-stone-100">
              <button onClick={() => setApproving(u)} className="flex-[2] h-11 rounded-xl bg-[#15803D] text-white font-semibold flex items-center justify-center gap-1" data-testid={`mobile-approve-${u.id}`}><Check className="w-4 h-4" />Approva</button>
              <button onClick={() => reject(u)} className="flex-1 h-11 rounded-xl bg-red-50 text-red-600 font-semibold flex items-center justify-center gap-1" data-testid={`mobile-reject-${u.id}`}><X className="w-4 h-4" />Rifiuta</button>
            </div>
          </div>
        ))}
      </div>
      {approving && <ApproveDialog item={approving} agents={agents} onClose={() => setApproving(null)} onDone={load} />}
    </div>
  );
}
